import { render, staticRenderFns } from "./addPaymentFee.vue?vue&type=template&id=1cfd4d76"
import script from "./addPaymentFee.vue?vue&type=script&lang=js"
export * from "./addPaymentFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports